import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import  { Router, ActivatedRoute } from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FirebaseService, CommonService, AlertService, AdminService, LeadService, ProfileService } from '../../_services/';
import { AngularFireAuth } from "@angular/fire/auth";
import {Observable, Subscription} from "rxjs";

declare var NgForm:any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm:FormGroup;
  submitted = false;
  returnUrl:string = '';
  user: Observable<firebase.User>;// Save logged in user data
  private subscription:Subscription;
  constructor(
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    private _firebase:FirebaseService, 
    private _common:CommonService,
    private _alert : AlertService,
    private formBuilder: FormBuilder,
    private _router : Router,
    private _admin: AdminService,
    public afAuth: AngularFireAuth,
    private route: ActivatedRoute,
    private _lead : LeadService,
    private _profile: ProfileService,
  ) { 
    
  }

  ngOnInit() {
    
    if(localStorage.getItem('uid')){
      // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] ? this.route.snapshot.queryParams['returnUrl'] :  '/contacts'; 
      this._router.navigate(['contacts']); 
    }
    this.loginForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email, Validators.maxLength(200)]], 
      password: [null, [Validators.required, Validators.minLength (6)]]
    })  
        
  }

  get fval() {
    return this.loginForm.controls;
  }

  onFormSubmit():void {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    let form = this.loginForm.value;
    
    this._common.showLoader(true);
    this._firebase.SignIn(form.email, form.password).then(res => {
      this.ngZone.run(() => {
        // code to get the basic user detail from contacts table....
        this.subscription = this._lead.getDesignerList(res.user.uid).subscribe(result=>{
          this._common.showLoader(false);
          if(result.length===0){
            this._alert.error("Contact information not available!");      
          }
          else {
            this._profile.getProfilePhoto(result[0].payload.doc.data()['id']).subscribe(resp=>{
              localStorage.setItem('uid',res.user.uid);
              localStorage.setItem('rs-email',res.user.email);    
              localStorage.setItem('contactId',result[0].payload.doc.data()['id'] ? result[0].payload.doc.data()['id'] :'');
              localStorage.setItem('firstName',result[0].payload.doc.data()['first_name'] ? result[0].payload.doc.data()['first_name'] :'');
              localStorage.setItem('lastName',result[0].payload.doc.data()['last_name'] ? result[0].payload.doc.data()['last_name'] : '');
              localStorage.setItem('profileImagePath', resp && resp.length>0 && resp[0].payload.doc.data()['fbs_download_url'] ? resp[0].payload.doc.data()['fbs_download_url'] : '');
              this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/contacts';
              this._common.navigate (this.returnUrl);
  
            },err2=>{
              this._alert.error(err2.message ? err2.message : 'Something went wrong while fetching profile photo');
            })
  
          }
        },err=>{
          this._alert.error(err.message);
        })
        
      });
      // this._firebase.SetUserData(res.user);
      this.user = this.afAuth.authState;      
    }).catch((err) => {
      this._common.showLoader(false);
      this._alert.error(err.message);
    })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }
  
}
